class ClassName {
	constructor(sel) {
		// view
		this.component = document.querySelector(sel);

		if (this.component) {
			this.init();
		}
	}

	init() {}
}

const example = new ClassName(".example");
